<template>
    <div :class="['wrapper', classes]" class="contentClass">
  

        <!-- Content Wrapper. Contains page content -->
        <IndexContainer/>
        <!-- /.content-wrapper -->
        <!-- Main Footer -->

        <!-- <footer class="main-footer" style="margin-left: 0px">
            <strong>Copyright &copy; {{year}}
                <a href="https://www.nuwarobotics.com/">NUWA Robotics</a>.</strong> All rights reserved.
        </footer> -->
        <BackTop/>
    </div>
    <!-- ./wrapper -->
</template>

<script>
    import faker from 'faker'
    import { mapState } from 'vuex'
    import config from '../config'
    import Sidebar from './Sidebar'
    import 'hideseek'
    import IndexContainer from './info.vue'
    import BackTop from './views/BackTop.vue'
    export default {
        name: 'Dash',
        components: {
            Sidebar,
            IndexContainer,
            BackTop
        },
        data: function () {
            const email = this.$store.state.user ? this.$store.state.user : ''
            const token = this.$store.state.token ? this.$store.state.token : ''
            let isAdmin = false
            // if (email && email.indexOf(config.defaultAdminMailDomain) > -1) {
            //     isAdmin = true
            // }
            if (this.$route.path.match(/^\/developerAdmin/i)) {
                isAdmin = true
            }
            let protocol = window.location.protocol
            let env = window.location.hostname.split('.')[0]
            let forumPort = env === 'localhost' ? '4567' : '80'
            let port = env === 'localhost' ? '8060' : '80'
            if (protocol === 'https:') {
                forumPort = '443'
                port = '443'
            }
            env = window.location.hostname
            return {
                // section: 'Dash',
                year: new Date().getFullYear(),
                lang: '',
                email: email,
                token: token,
                isAdmin,
                classes: {
                    fixed_layout: config.fixedLayout,
                    hide_logo: config.hideLogoOnMobile
                },
                error: '',
                forumUrl: protocol + '//' + env + ':' + forumPort + '/forum/',
                gitbookUrl: protocol + '//' + env + ':' + port + '/gitbook/'
            }
        },
        computed: {
            ...mapState([
                'userInfo'
            ]),
            demo () {
                return {
                    displayName: faker.name.findName(),
                    avatar: faker.image.avatar(),
                    email: faker.internet.email(),
                    randomCard: faker.helpers.createCard()
                }
            }
        },
        methods: {
            changeloading () {
                this.$store.commit('TOGGLE_SEARCHING')
            },
            $_admin_dash_back () {
                this.$router.go(-1)
            },
            $_admin_dash_change_lang (lang) {
                if (lang) {
                    this.$root.$i18n.locale = lang
                    this.lang = lang
                } else {
                    this.$root.$i18n.locale = this.lang
                }
            },
            $_admin_index_login () {
                this.$router.push({name: 'userLogin'})
            },
            $_admin_index_register () {
                this.$router.push({name: 'userRegister'})
            }
        },
        mounted () {
            this.$store.state.isFooterShow = true
        }
    }
</script>

<style lang="scss">

    .contentClass{
        margin-top: -8px;
        height: 100%;
    }
    .wrapper.fixed_layout {
    .main-header {
        position: fixed;
        width: 100%;
    }

    .content-wrapper {
        padding-top: 50px;
    }

    .main-sidebar {
        position: fixed;
        height: 100vh;
    }
    }

    .wrapper.hide_logo {
    @media (max-width: 767px) {
        .main-header .logo {
            display: none;
        }
    }
    }

    .logo-mini,
    .logo-lg {
        text-align: left;

    img {
        padding: .4em !important;
    }
    }

    .logo-lg {
    img {
        display: -webkit-inline-box;
        width: 25%;
    }
    }

    .user-panel {
        height: 4em;
    }

    hr.visible-xs-block {
        width: 100%;
        background-color: rgba(0, 0, 0, 0.17);
        height: 1px;
        border-color: transparent;
    }

    ul .indexSteps {
        white-space: nowrap;
        overflow: hidden;
        background: #a7acb5;
        margin-bottom: 52px;
        border-radius: 3px 3px 0 0;
    }
    ul.indexSteps .indexStepLi {
        width: 15%;
        line-height: 68px;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        transition: background-color .3s;
        display: inline-block;
        background: #3c8dbc;
        border-right: 0px solid rgba(0,0,0,.06);
    }
    ul.indexSteps .indexStepLi.current:first-child, ul.indexSteps .indexStepLi.finish:first-child {
        border-left: none;
    }
    ul.indexSteps .indexStepLi.current {
        background: #48e7cf;
    }
    ul.indexSteps .indexStepLi.current, ul.indexSteps .indexStepLi.finish {
        border-left: 1px solid hsla(0,0%,100%,.2);
        border-right: none;
    }
    .indexSteps .indexStepLi span {
        width: 24px;
        height: 24px;
        line-height: 22px;
        color: #fff;
        font-size: 14px;
        border-radius: 50%;
        border: 1px solid #fff;
        text-align: center;
        display: inline-block;
        margin-right: 10px;
    }
    .main-header>.navbar2 {
        margin-left: 0px;
    }
    .indexSteps a {
        color: #fff;
    }
    .marginTopMinus50px {
        margin-top: -50px;
    }
    .marginTopMinus70px {
        margin-top: -70px;
    }
    ul.navbar-nav {
        padding-right: 10px;
    }
    ul.resourceSteps .resourceStepLi {
        line-height: 34px;
        color: black;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        transition: background-color .3s;
        background: #fff;
        border-right: 0px solid rgba(0,0,0,.06);
    }
    .w100 {
        width: 100%;
    }
    .carousel-caption-sp {
        width: 100%;
        left: 0%;
        right: 0%;
        background-color: #a7acb577;
    }
</style>



// WEBPACK FOOTER //
// NewIndex.vue?c8436a00